import { ImageFragment } from '@/graphql/fragments/image';
import { PodcastBaseFragment } from '@/graphql/fragments/posdcast';
import { TopicsBaseFragment } from '@/graphql/fragments/topics';
import { gql } from '@apollo/client';

export const QUERY_PODCAST = gql`
  query podcast($slug: [String], $userId: ID!) {
    podcasts(pagination: { limit: 1 }, sort: "publicationDate:desc", filters: { slug: { in: $slug } }) {
      data {
        id
        attributes {
          title
          slug
          briefDescription
          subHeader
          cover {
            data {
              ...ImageFragment
            }
          }
          listenings(filters: { user: { id: { eq: $userId } } }) {
            data {
              id
              attributes {
                listeningTime
                duration
              }
            }
          }
          themes {
            data {
              attributes {
                theme
                topic {
                  data {
                    attributes {
                      topic
                    }
                  }
                }
              }
            }
          }
          DefaultContentTemplate {
            __typename
            ... on ComponentCommonH3 {
              text
            }
            ... on ComponentCommonMedia {
              media {
                data {
                  attributes {
                    url
                    alternativeText
                  }
                }
              }
            }
            ... on ComponentCommonTitle {
              title
            }

            ... on ComponentCommonAuthorDetailed {
              authors {
                data {
                  attributes {
                    name
                    role
                    bio
                    avatar {
                      data {
                        ...ImageFragment
                      }
                    }
                  }
                }
              }
            }

            ... on ComponentCommonDivider {
              id
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            ... on ComponentCommonTextEditor {
              markdownText
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            ... on ComponentCommonBullet {
              item {
                text
              }
            }

            ... on ComponentCommonQuote {
              quote
            }

            ... on ComponentCommonFaqComponent {
              faq {
                title
                description
              }
            }
            ... on ComponentCommonTags {
              id
            }
            ... on ComponentCommonRelatedContent {
              id
            }

            ... on ComponentCommonDownloadableContentList {
              list {
                title
                description
                content {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }

            ... on ComponentCommonAudio {
              transcription
              audio {
                data {
                  attributes {
                    url
                  }
                }
              }
            }

            ... on ComponentCommonInPartnershipWith {
              partnership
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_FETCH_PODCAST_PAGE = gql`
  query PodcastPage {
    podcastPage {
      data {
        attributes {
          intro {
            title
            description
            thumbnail {
              data {
                ...ImageFragment
              }
            }
          }
          topics {
            data {
              attributes {
                ...TopicsBaseFragment
              }
            }
          }
          latestTitle
          moreButotnTItle
          chooseAThemeTitle
          getInTouchSection {
            boxText
            buttonText
            titleModal
            descriptionModal
            emailPlaceholder
            submitText
            yourTextPlaceholder
            thanksTitle
            thanksDescription
          }
          questionsSection {
            boxText
            buttonText
            titleModal
            descriptionModal
            emailPlaceholder
            submitText
            yourTextPlaceholder
            thanksTitle
            thanksDescription
            guests {
              data {
                id
                attributes {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  ${TopicsBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_PODCASTS_PAGEABLE = gql`
  query fetchPodcastsPageable($page: Int, $userId: ID) {
    podcasts(pagination: { page: $page, pageSize: 5 }, sort: "publicationDate:desc") {
      data {
        id
        attributes {
          ...PodcastBaseFragment
        }
      }
      meta {
        pagination {
          page
          pageCount
          total
        }
      }
    }
  }
  ${PodcastBaseFragment}
`;

export const QUERY_FETCH_LATEST_PODCASTS_BY_THEME = gql`
  query latestPodcastsByTheme($theme: String!, $limit: Int, $userId: ID) {
    podcasts(
      filters: { themes: { theme: { eq: $theme } } }
      pagination: { limit: $limit }
      sort: "publicationDate:desc"
    ) {
      data {
        attributes {
          ...PodcastBaseFragment
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
  ${PodcastBaseFragment}
`;

export const QUERY_FETCH_LATEST_PODCASTS = gql`
  query fetchLatestPodcasts($slug: [String], $userId: ID) {
    podcasts(pagination: { limit: 2 }, sort: "publicationDate:desc", filters: { slug: { notIn: $slug } }) {
      data {
        id
        attributes {
          ...PodcastBaseFragment
        }
      }
    }
  }
  ${PodcastBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FIND_LISTENING_TIME = gql`
  query findPodcastListeningTime($userId: ID!, $podcastId: ID!) {
    podcastListeningTimes(filters: { user: { id: { eq: $userId } }, podcast: { id: { eq: $podcastId } } }) {
      data {
        id
        attributes {
          listeningTime
          duration
        }
      }
    }
  }
`;
